<template>
    <ListeBonRetour/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ListeBonRetour from "@/components/GesCom/BonRetour/ListeBonRetour.vue";
    export default defineComponent({
      name: "ListeBonRetourPage",
      components: {
        ListeBonRetour,
      },
    });
  </script>